import { Typography, Stack, DialogActions } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  NoDataSkeleton,
  ConfirmationDialog,
  CustomButton,
} from '../../../../../common/components';
import PaymentsTable from './PaymentsTable';
import PayIntentForm from './PayIntentForm';
import useDifferimentPaymentDialog from '../../hooks/useDifferimentPaymentDialog';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import InvoicePaymentDialog from './InvoicePaymentDialog';

const DifferimentPaymentDialog = ({ open, onClose, detail, isLoading, onPrint, onRefresh }) => {
  const rows = detail?.payments || [];
  const { state, actions } = useDifferimentPaymentDialog(detail, onRefresh);
  const [deleteId, setDeleteId] = useState(null);
  const [markPaidId, setMarkPaidId] = useState(null);

  return (
    <DialogContainer open={open} onClose={onClose} size="large">
      <DialogTitle>Pagos de diferimiento - Contrato: {detail?.contract_number}</DialogTitle>
      <DialogBody>
        {isLoading ? (
          <Typography>Cargando...</Typography>
        ) : !detail ? (
          <NoDataSkeleton />
        ) : (
          <>
            <PayIntentForm
              installmentsToPay={state.installmentsToPay}
              cuotaPura={state.cuotaPura}
              totalFromForm={state.totalFromForm}
              isSubmitting={state.isSubmitting}
              pendingInstallments={state.pendingInstallments}
              onInstallmentsChange={actions.setInstallmentsToPay}
              onCuotaPuraChange={actions.setCuotaPura}
              onSubmit={actions.handleSubmit}
            />
            <PaymentsTable
              rows={rows}
              onPrint={onPrint}
              onPrintInvoice={(invoiceUuid) => actions.printInvoice(invoiceUuid)}
              onMarkPaid={(uuid) => setMarkPaidId(uuid)}
              onDelete={(uuid) => setDeleteId(uuid)}
              onGenerateQr={(uuid) => actions.generateQr(uuid)}
              onInvoice={(uuid) => actions.openInvoiceDialog(uuid)}
            />
            {state.isGeneratingQr && (
              <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 2 }}>
                <CircularProgress size={20} />
                <Typography variant="body2" color="text.secondary">
                  Generando QR...
                </Typography>
              </Stack>
            )}
          </>
        )}
      </DialogBody>
      <DialogActions>
        <Stack direction="row" spacing={1} />
      </DialogActions>
      <ConfirmationDialog
        open={Boolean(deleteId)}
        onClose={() => setDeleteId(null)}
        onConfirm={() => {
          actions.deletePayment(deleteId);
          setDeleteId(null);
        }}
        title="Eliminar pago"
        message="Esta acción eliminará el registro de pago de diferimiento."
      />
      <ConfirmationDialog
        open={Boolean(markPaidId)}
        onClose={() => setMarkPaidId(null)}
        onConfirm={() => {
          actions.markPaid(markPaidId);
          setMarkPaidId(null);
        }}
        title="Marcar como pagado"
        message="¿Confirmás marcar este pago como cobrado?"
        confirmText="Marcar pagado"
      />
      {state.qrDialog && (
        <DialogContainer open size="sm" onClose={actions.closeQrDialog}>
          <DialogTitle>QR de diferimiento</DialogTitle>
          <DialogBody>
            {state.qrDialog.qr_image_base64 ? (
              <img
                alt="QR diferimiento"
                src={`data:image/png;base64,${state.qrDialog.qr_image_base64}`}
                style={{ maxWidth: '100%', display: 'block', margin: '0 auto' }}
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                {state.qrDialog.qr_data || 'QR generado'}
              </Typography>
            )}
          </DialogBody>
          <DialogActions>
            <Stack direction="row" spacing={1}>
              <CustomButton onClick={actions.closeQrDialog} variant="base">
                Cerrar
              </CustomButton>
            </Stack>
          </DialogActions>
        </DialogContainer>
      )}
      {state.invoiceDialog && (
        <InvoicePaymentDialog
          open={Boolean(state.invoiceDialog)}
          onClose={actions.closeInvoiceDialog}
          invoiceDate={state.invoiceDate}
          onInvoiceDateChange={actions.setInvoiceDate}
          salePoints={state.salePoints}
          salePointsLoading={state.salePointsLoading}
          selectedSalePointId={state.selectedSalePointId}
          onSalePointChange={(e) => actions.setSelectedSalePointId(e.target.value)}
          makeElectronicInvoice={state.makeElectronicInvoice}
          onMakeElectronicInvoiceChange={actions.setMakeElectronicInvoice}
          selectedSalePoint={state.selectedSalePoint}
          error={state.invoiceError}
          onSubmit={actions.submitInvoice}
          isSubmitting={state.isInvoicing}
        />
      )}
    </DialogContainer>
  );
};

export default DifferimentPaymentDialog;
